var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-breadcrumb',{staticClass:"minus-gutters",attrs:{"items":_vm.breadcrumbItems}}),_c('iframe',{staticClass:"w-100",attrs:{"id":"u83_input","scrolling":"auto","frameborder":"1","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":"","src":_vm.iframeUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }